import { CustomerDashboardState } from '@ligo/dashboard/customer/store';
import Vue from 'vue';
import { Store } from 'vuex';

export function useStore() {
  return Vue['Store'] as Store<CustomerDashboardState>;
}
